import { render, staticRenderFns } from "./AccountingBooksForm.vue?vue&type=template&id=2b0d28ec&"
import script from "./AccountingBooksForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksForm.vue?vue&type=style&index=0&id=2b0d28ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports